import { Avatar, Badge, Group, Stack, Text } from "@mantine/core";
import StatusText from "../../../../common/components/DataTable/StatusText";
import {
  formatGender,
  getTravellerInitials,
  getTravellerName,
} from "../../utils/allPolicyHelpers";
import classes from "./TravellerPolicyDrawer.module.css";

const TravellerDrawerHeader = ({ traveller }) => {
  if (!traveller) return null;
  const subline = [
    traveller.nationality_name,
    formatGender(traveller.gender),
    traveller.dob ? `DOB: ${traveller.dob}` : null,
  ].filter(Boolean).join(" · ");

  return (
    <div className={classes.header}>
      <Group justify="space-between" align="flex-start" wrap="wrap">
        <Group gap="md" wrap="wrap" style={{ flex: 1, minWidth: 0 }}>
          <Avatar radius="xl" size="lg" color="orange">
            {getTravellerInitials(traveller)}
          </Avatar>
          <Stack gap={6} style={{ flex: 1, minWidth: 0 }}>
            <Text fw={700} size="lg">{getTravellerName(traveller)}</Text>
            <Text size="sm" c="rgba(255,255,255,0.85)">{subline}</Text>
            <Group gap={6} wrap="wrap">
              {traveller.is_primary ? (
                <Badge size="sm" color="yellow" variant="filled">★ Primary</Badge>
              ) : null}
              <StatusText
                status={traveller.policy_status_traveller_wise}
                field="policy_status_traveller_wise"
              />
              <StatusText status={traveller.status} field="status" />
              <Badge size="sm" variant="light" color="gray">{traveller.cover_type}</Badge>
            </Group>
          </Stack>
        </Group>
      </Group>
      <div className={classes.contactBar}>
        <Text size="sm" className={classes.contactItem}>✉ {traveller.email || "—"}</Text>
        <Text size="sm" className={classes.contactItem}>📞 {traveller.phone_number || "—"}</Text>
        <Text size="sm" className={classes.contactItem}>🎫 {traveller.cover_number || "—"}</Text>
        <Text size="sm" className={classes.contactItem}>🏢 {traveller.tour_operator_name || "—"}</Text>
      </div>
    </div>
  );
};

export default TravellerDrawerHeader;
